module.exports = __webpack_public_path__ + "img/santander.ed68f2c0.png";